export const _updateLocationTypeData = (state, action) => action.payload;

export const _updateTypeData = (state, action) => {
  state.type = action.payload;
};

export const _setLocationTypeData = (state, action) => action.payload;


